import React from 'react'
import {ThemeProvider, withTheme} from 'styled-components'
import {compose} from 'utils/reactUtils'
import {catchError} from 'utils/errorUtils'
import UnexpectedError from 'components/unexpected-error'
import {CLIENT_THEME} from 'theme'
import Header from './header'
import Footer from './footer'
import Content from './Content'

import ShellView from './ShellView'
import DisplaySize from '../DisplaySize'
import Notifications from 'components/notifications'

const Shell = ({children, brand, theme, logout, email}) => (
  <ShellView>
    <ThemeProvider theme={CLIENT_THEME[brand] || theme}>
      <DisplaySize>
        <Header logout={logout} email={email} />
      </DisplaySize>
    </ThemeProvider>
    <Notifications />
    <Content>{children}</Content>
    <Footer />
  </ShellView>
)

export default compose(catchError(UnexpectedError), withTheme)(Shell)
